import React from 'react';
import './Badge.scss';

export interface StatusConfig {
  label: string;
  className: string;
}

export interface BadgeProps {
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  // Новые пропсы для статусов
  status?: string;
  statusConfigs?: Record<string, StatusConfig>;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  status,
  statusConfigs,
}) => {
  if (status && statusConfigs) {
    const config = statusConfigs[status] ||
      statusConfigs.default || {
        label: 'Unknown',
        className: 'default',
      };

    const badgeClasses = ['badge', 'badge--status', config.className, className]
      .filter(Boolean)
      .join(' ');

    return (
      <span className={badgeClasses} onClick={onClick}>
        {config.label}
      </span>
    );
  }

  // Обычный badge
  const badgeClasses = [
    'badge',
    `badge--${variant}`,
    `badge--${size}`,
    onClick ? 'badge--clickable' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={badgeClasses} onClick={onClick}>
      {children}
    </span>
  );
};

export default Badge;
